module.exports = __webpack_public_path__ + "img/sus-top.5b058f2.svg";